<template>
    <div class="md-layout">
        <div class="md-layout-item md-size-65">
            <form ref="edit_demand_form" @submit.prevent="updateDemand">
                <md-card>
                    <md-card-header class="md-card-header-icon md-card-header-blue">
                        <div class="md-layout">
                            <div class="md-layout-item">
                                <div class="card-icon">
                                    <font-awesome-icon class="md-icon" :icon="['fa', 'pen']" />
                                </div>
                                <h4 class="title">Modification d'une demande</h4>
                            </div>
                        </div>
                    </md-card-header>
                    <demand-form :demand="demand" :errors="errors" @selected="(e) => this.linkedDemands = e"></demand-form>
                    <md-card-actions md-alignment="left">
                        <md-button type="submit" class="md-success">
                            Enregistrer
                        </md-button>
                        <md-button class="md-warning" @click="goBack">
                            Retour
                        </md-button>
                    </md-card-actions>
                </md-card>
            </form>
        </div>
        <div class="md-layout-item md-size-35">
            <demand-linked :demand="demand" :linkedDemands="linkedDemands"></demand-linked>
        </div>
    </div>
</template>

<script>
import DemandForm from "@/pages/Demands/components/DemandForm";
import DemandLinked from "@/pages/Demands/components/DemandLinked";
export default {
    name: "DemandEdit",
    components: {
        DemandForm, DemandLinked
    },
    data() {
        return {
            demand: {
                date: null,
                client: null,
                site: null,
                prospect: null,
                demand_types: [],
                subject: null,
                message: null,
            },
            linkedDemands: [],
            errors: []
        }
    },
    methods: {
        async getDemandDetails() {
            const { data } = await this.$store.dispatch('demands/getDemandDetails', {
                demandId: this.$route.params.demandId
            })
            let demand_types = []
            data.demand_types.map(demandType => {
                demand_types.push(demandType.id)
            })
            this.demand = {
                ...data,
                date: this.$moment(data.date).format(),
                demand_types: demand_types
            }
        },
        async updateDemand() {
            this.errors = []
            if((this.demand.prospect !== null && this.demand.prospect.length > 0) || this.demand.client) {
                try {
                    await this.$store.dispatch('demands/updateDemand', {
                        demandId: this.demand.id,
                        date: this.$moment(this.demand.date).format('YYYY-MM-DD HH:mm:ss'),
                        client_id: this.demand.client?.id ?? null,
                        site_id: this.demand.site?.id ?? null,
                        prospect: this.demand.prospect,
                        types: this.demand.demand_types,
                        subject: this.demand.subject,
                        message: this.demand.message
                    })
                    await this.$store.dispatch('alerts/success', 'Demande modifiée')
                    this.goBack()
                } catch (e) {
                    this.errors = e.response.data.errors
                }
            } else {
                await this.$store.dispatch('alerts/warning', 'Le choix d\'un client ou l\'ajout d\'un prospect est obligatoire')
            }
        },
        goBack() {
            this.$router.back()
        }
    },
    mounted() {
        this.getDemandDetails()
    }
}
</script>

<style scoped>

</style>
